/**
 * 学校端的接口
 */
import http from '../http'
import Qs from 'qs'

// 获取学校详情 v1.3.1 废弃
// const getSchoolDetailBySch = params =>
//   http.get('/sysSchools/schoolDetail', { params }).then(res => res.data);

// 获取学校详情(新)
const getSchoolDetailNew = (params) =>
  http.get('/sysSchools/getSchoolDetailNew', { params }).then((res) => res.data)
// 学校修改详情
const editSysSchoolBySch = (params) =>
  http
    .put('/sysSchools/school', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)

// 获取学生列表
const getStudentQuerylist = (params) =>
  http.get('/student/querylist', { params }).then((res) => res.data)
// 获取学生列表(v1.3.1)
const getStudentQuerylistNew = (params) =>
  http.get('/student/getStudentList', { params }).then((res) => res.data)
// 获取学生详情(v1.3.1)
const getStudentDetail = (params) =>
  http.get('/student/getByUserId', { params }).then((res) => res.data)
// 通过code获取字典值（v1.3.1）
const getByDictCode = (params) =>
  http.get('/dictionary/getByDictCode', { params }).then((res) => res.data)
// 添加家长
const postParentAdd = (params) =>
  http
    .post('/parent/add', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 获取家长列表
const getStudentParentList = (params) =>
  http.get('/parent/querySingle', { params }).then((res) => res.data)
// 添加学生
const postStudentAdd = (params) =>
  http
    .post('/student/add', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 修改学生
const putStudentUpdate = (params) =>
  http
    .put('/student/update', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 删除学生
const delStudentDelete = (params) =>
  http
    .delete(
      '/student/delete',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data)
// 导出家长列表
const getParentExport = (params) =>
  http.get('/parent/export', { params }).then((res) => res.data)
// 获取家长列表
const getParentQuerylist = (params) =>
  http.get('/parent/querylist', { params }).then((res) => res.data)
// 修改家长
const putParentUpdate = (params) =>
  http
    .put('/parent/update', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 删除家长
const delParentDelete = (params) =>
  http
    .delete(
      '/parent/delete',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data)
// 删除教师
const delteacherDelete = (params) =>
  http
    .delete(
      '/teacher/delete',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data)
// 获取服务端老师
const getTeacherQueryListByOrn = (params) =>
  http.get('/teacher/queryList/org', { params }).then((res) => res.data)
// 获取老师列表
const getTeacherDynamicList = (params) =>
  http.get('/teacher/DynamicList', { params }).then((res) => res.data)
// 获取校区列表(v1.3.1)
const getBranchList = (params) =>
  http.get('/sysSchools/listAll', { params }).then((res) => res.data)
// 获取场地列表
const getPlacesQuerylist = (params) =>
  http.get('/sys/places/querylist', { params }).then((res) => res.data)
// 获取场地类型列表
const getPlacesTypeQuerylist = (params) =>
  http.get('/sys/places/type/querylist', { params }).then((res) => res.data)
// 新增场地
const postPlacesAdd = (params) =>
  http
    .post('/sys/places/add', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 修改场地
const putPlacesUpdate = (params) =>
  http
    .put('/sys/places/update', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 删除场地
const delPlacesDelete = (params) =>
  http
    .delete(
      '/sys/places/delete',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data)
// 新增场地类型
const postPlacesTypeAdd = (params) =>
  http
    .post('/sys/places/type/add', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 修改场地类型
const putPlacesTypeUpdate = (params) =>
  http
    .put('/sys/places/type/update', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 删除场地类型
const delPlacesTypeDelete = (params) =>
  http
    .delete(
      '/sys/places/type/delete',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data)
// 学生报名统计
const getStuEnroll = (params) =>
  http.get('/course/stat/stuEnroll', { params }).then((res) => res.data)
// 课程考勤统计
const getCourseAttendance = (params) =>
  http.get('/sign/sch', { params }).then((res) => res.data)
// （后台 ）学校某年纪的班级列表
const getClassListByschool = (params) =>
  http.get('/class/class', { params }).then((res) => res.data)
// v1.3.1 导出班级列表
const getClassListByschoolData = (params) =>
  http
    .get('/class/exportByCondition', { params, responseType: 'blob' })
    .then((res) => res)
// 新增年级
const postAddGradeBySchool = (params) =>
  http
    .post('/sysGrades/grade', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 修改年级
const putAddGradeBySchool = (params) =>
  http
    .put('/sysGrades/grade', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 删除年级
const delGradeBySchool = (params) =>
  http
    .delete(
      '/sysGrades/grade',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data)

// 设置年级毕业
const putGradeGraduateBySchool = (params) =>
  http
    .put('/sysGrades/gradeGraduate', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 新增班级
const postAddClassBySchool = (params) =>
  http
    .post('/class', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 修改班级
const putAddClassBySchool = (params) =>
  http
    .put('/class/class', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 删除班级
const delClassBySchool = (params) =>
  http
    .delete(
      '/class',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data)
// 学校解除服务 v1.3.3废除
// const putRemoveOrgBySchool = params =>
//   http
//     .put('/sysSchools/school/removeOrg', params, {
//       headers: { 'Content-Type': 'application/json' }
//     })
//     .then(res => res.data);
// 学校关联服务
const postAssociatedOrgBySchool = (params) =>
  http
    .post('/sysSchools/school/associatedOrg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 服务商家展示
const getSysOrgWeixinAccts = (params) =>
  http.get('/sysOrgWeixinAccts', { params }).then((res) => res.data)

// todo 课程
// 查询学校已引进课程列表
const getCourseDefineSchoolIntroPage = (params) =>
  http.get('/courseDefine/schoolIntroPage', { params }).then((res) => res.data)
// 查询学校自建课程列表
const getCourseDefineSchoolPage = (params) =>
  http.get('/courseDefine/schoolPage', { params }).then((res) => res.data)
// 查询学校待审核课程列表
const getCourseDefineSchoolCheckPage = (params) =>
  http.get('/courseDefine/schoolCheckPage', { params }).then((res) => res.data)
// 课程类型列表
const getCourseTypesAll = (params) =>
  http.get('/courseType/courseTypes', { params }).then((res) => res.data)
// 课程入围学校列表
const getCourseSelectSchoolPage = (params) =>
  http.get('/courseDefine/selectSchoolPage', { params }).then((res) => res.data)

// 学校关联服务
const postAddCourseClassBySchool = (params) =>
  http
    .post('/courseClass', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 学校课班列表
const getSchoolClassPageBySch = (params) =>
  http.get('/courseClass/schoolClassPage', { params }).then((res) => res.data)
// 批量修改课班状态（确定，驳回，发布，取消发布）
const setClassroomStateBySch = (params) =>
  http
    .put('/courseClass/classroomState', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// todo 考勤
// 考勤明细
const getSignDetailBySchool = (params) =>
  http.get('/sign/sch/sign', { params }).then((res) => res.data)
// 请假明细
const getLeaveDetailBySchool = (params) =>
  http
    .get('/courseClass/class/leave/detail', { params })
    .then((res) => res.data)
// 缺勤明细
const getNosignDetailBySchool = (params) =>
  http.get('/sign/sch/nosign', { params }).then((res) => res.data)

// todo 课程报名统计
// 班级报名统计-已报名
const getClassEnrollBySchool = (params) =>
  http.get('/course/stat/classEnroll', { params }).then((res) => res.data)
// 班级报名统计-未报名
const getClassNoEnrollBySchool = (params) =>
  http.get('/course/stat/classNoEnroll', { params }).then((res) => res.data)

// todo 报班管理情况
// 课班报名情况列表
const getcourseClassEnrollBySchool = (params) =>
  http.get('/courseClass/class/enroll', { params }).then((res) => res.data)
// 课程介绍
const getCourseDetailBySchool = (params) =>
  http.get('/course/mien/detail', { params }).then((res) => res.data)
// 学校端 - 报班管理情况- 学员列表
const getCourseStudentListBySchool = (params) =>
  http.get('/course/enroll/student', { params }).then((res) => res.data)
//  学校端 - 报班管理情况- 学员添加
const addCourseStudentListBySchool = (params) =>
  http
    .post('/course/enroll/student', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
//  学校端 - 报班管理情况- 学员移除
const delCourseStudentListBySchool = (params) =>
  http
    .put('/course/enroll/student', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
//  学校端 - 报班管理情况- 学员停课
const stopCourseStudentBySchool = (params) =>
  http
    .put('/course/stop/student', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 学校端 - 报班管理情况- 班级学员课班情况
const getCourseClassroomStuListBySchool = (params) =>
  http.get('/course/classroom/student', { params }).then((res) => res.data)
// 学校端 - 报班管理情况- 班级学员课班情况删除
const delCourseClassroomStuBySchool = (params) =>
  http
    .put('/course/classroom/student', params, {
      headers: { 'Content-Type': '	application/json' }
    })
    .then((res) => res.data)
// 学校端 - 报班管理情况- 课班排课课表
const getCourseClassroomScheduleBySchool = (params) =>
  http.get('/course/classroom/schedule', { params }).then((res) => res.data)
// 学校端 - 报班管理情况- 课班过程评价
const getCourseClassroomAppriseBySchool = (params) =>
  http.get('/course/classroom/apprise', { params }).then((res) => res.data)
// 学校端 - 报班管理情况- 课程总评
const getCourseClassroomEndAppriseBySchool = (params) =>
  http.get('/course/classroom/endApprise', { params }).then((res) => res.data)
// 学校端 - 报班管理情况- 查看课班的所有课程
const getCourseClassDetailsBySchool = (params) =>
  http.get('/courseClassDetails/details', { params }).then((res) => res.data)

// 学校端 - 日配餐详情列表
const getDayFoodPageBySchool = (params) =>
  http.get('/userOrder/foodOrgOrderPage', { params }).then((res) => res.data)
// 分页查询日配餐列表-学校端
const page2School = (params) =>
  http
    .get('/supplymealinfos/qrysuppmeal/page2School', { params })
    .then((res) => res.data)
// 学校段 - 合作关联服务详情 // 学校端 - 日配餐详情列表
const getAssociatedOrgBySchool = (params) =>
  http
    .get('/sysSchools/school/associatedOrg/detail', { params })
    .then((res) => res.data)
// 课程表-学校课班列表
const getschoolClassPage = (params) =>
  http.get('/courseClass/schoolClassPage', { params }).then((res) => res.data)
// 课程表-添加排课
const creatTimetables = (params) =>
  http
    .post('/courseClass/creatTimetables', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 课程表-设置上课时间_删除
const delcourseClassPeriod = (params) =>
  http
    .delete(
      '/courseClassPeriod',
      { params },
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    )
    .then((res) => res.data)
// 课程表-设置上课时间_新增
const addcourseClassPeriod = (params) =>
  http
    .post('/courseClassPeriod', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 课程表-设置上课时间_修改
const editcourseClassPeriod = (params) =>
  http
    .put('/courseClassPeriod', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 课程表-设置上课时间(批量)
const saveClassPeriod = (params) =>
  http
    .post('/courseClass/saveClassPeriod', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 课程表-添加节次
const addTimetable = (params) =>
  http
    .post('/courseClass/addTimetable', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// const getAssociatedOrgBySchool = (params) =>http.get('/sysSchools/school/associatedOrg/detail', { params }).then((res) => res.data)

// ?系统设置
// 学校端 - 学校提醒修改
const putSysSchoolsRemindBySch = (params) =>
  http
    .put('/sysSchools/remind', params, {
      headers: { 'Content-Type': '	application/json' }
    })
    .then((res) => res.data)
// ? 导入
// 学生导入
const importStudentBySch = (params) =>
  http
    .post(`/student/import`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => res.data)
// 教师导入
const importTeacherBySch = (params) =>
  http
    .post(`/teacher/importTeacher`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => res.data)
// 家长导入
const importParentBySch = (params) =>
  http
    .post(`/parent/import`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => res.data)

//  查询学校以及合作服务的所有教师动态下拉列表
const getQuerySchoolOrgTeacher = (params) =>
  http.get('/teacher/querySchoolOrgTeacher', { params }).then((res) => res.data)

// 获取学校订单列表
const getSchoolOrderList = (params) =>
  http.get('/userOrder/schoolOrderPage', { params }).then((res) => res.data)

// 获取学校退款订单列表
const getRefundOrderList = (params) =>
  http
    .get('/userOrder/schoolRefundOrderPage', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
    .then((res) => res.data)

// 学校- 数据概览
const getBasicData = (params) =>
  http.get('/stat/school/view/basicData', { params }).then((res) => res.data)

// 学校 - 营收统计
const getRevenueData = (params) =>
  http.get('/stat/school/view/revenue', { params }).then((res) => res.data)

// 学校- 最受欢迎课班/托管TOP5
const getTop5Data = (params) =>
  http.get('/stat/school/view/top5', { params }).then((res) => res.data)

// 学校  - 学校订餐统计
const getFoodData = (params) =>
  http.get('/stat/school/sch/food', { params }).then((res) => res.data)

// 学校 - 托管概览
const getTuoguanData = (params) =>
  http.get('/stat/school/view/tuoguan', { params }).then((res) => res.data)

// 学校 - 课程概览
const getCourseTypeData = (params) =>
  http.get('/stat/school/view/courseType', { params }).then((res) => res.data)

// 学校 -机构 - 数据概览
const getOrgBasicData = (params) =>
  http
    .get('/stat/school/view/org/basicData', { params })
    .then((res) => res.data)

// 学校 -机构 - 最受欢迎课班/托管TOP5
const getOrgTop5Data = (params) =>
  http.get('/stat/school/view/org/top5', { params }).then((res) => res.data)

// 学校 -机构 - 学校订餐统计
const getFoodOrgData = (params) =>
  http.get('/stat/school/sch/org/food', { params }).then((res) => res.data)

// 学校 -机构 - 托管概览
const getOrgTuoguanData = (params) =>
  http.get('/stat/school/view/org/tuoguan', { params }).then((res) => res.data)

// 学校 -机构 - 课程概览
const getOrgCourseTypeData = (params) =>
  http
    .get('/stat/school/view/org/courseType', { params })
    .then((res) => res.data)

// 学校 - 获取机构列表 v1.3.3
const getSchoolOrgList = (params) =>
  http
    .get('/sysSchools/school/associatedOrg/detail/new', { params })
    .then((res) => res.data)

// 学校 - 获取学校关联的机构列表 v1.3.3
const getSchoolOrgListMore = (params) =>
  http.get('/sysSchools/getSchoolOrgNew', { params }).then((res) => res.data)

export default {
  getStuEnroll,
  getCourseAttendance,
  // getSchoolDetailBySch,
  editSysSchoolBySch,
  getStudentQuerylist,
  postParentAdd,
  getStudentParentList,
  postStudentAdd,
  putStudentUpdate,
  delStudentDelete,
  getParentQuerylist,
  putParentUpdate,
  getTeacherQueryListByOrn,
  getPlacesQuerylist,
  getPlacesTypeQuerylist,
  postPlacesAdd,
  postPlacesTypeAdd,
  putPlacesTypeUpdate,
  putPlacesUpdate,
  delPlacesDelete,
  delPlacesTypeDelete,
  delteacherDelete,
  getTeacherDynamicList,
  delParentDelete,
  getParentExport,
  getClassListByschool,
  getClassListByschoolData,
  postAddGradeBySchool,
  putAddGradeBySchool,
  delGradeBySchool,
  putGradeGraduateBySchool,
  postAddClassBySchool,
  putAddClassBySchool,
  delClassBySchool,
  // putRemoveOrgBySchool,
  getSysOrgWeixinAccts,
  getCourseDefineSchoolIntroPage,
  postAssociatedOrgBySchool,
  getCourseTypesAll,
  getCourseDefineSchoolPage,
  getCourseDefineSchoolCheckPage,
  getCourseSelectSchoolPage,
  postAddCourseClassBySchool,
  getSignDetailBySchool,
  getLeaveDetailBySchool,
  getNosignDetailBySchool,
  getClassEnrollBySchool,
  getClassNoEnrollBySchool,
  getcourseClassEnrollBySchool,
  getCourseDetailBySchool,
  getCourseStudentListBySchool,
  getCourseClassroomStuListBySchool,
  getCourseClassroomScheduleBySchool,
  getCourseClassroomAppriseBySchool,
  getCourseClassDetailsBySchool,
  getCourseClassroomEndAppriseBySchool,
  addCourseStudentListBySchool,
  delCourseStudentListBySchool,
  stopCourseStudentBySchool,
  delCourseClassroomStuBySchool,
  getDayFoodPageBySchool,
  getAssociatedOrgBySchool,
  getschoolClassPage,
  creatTimetables,
  delcourseClassPeriod,
  addcourseClassPeriod,
  editcourseClassPeriod,
  saveClassPeriod,
  addTimetable,
  getSchoolClassPageBySch,
  setClassroomStateBySch,
  putSysSchoolsRemindBySch,
  importStudentBySch,
  importTeacherBySch,
  importParentBySch,
  getQuerySchoolOrgTeacher,
  getSchoolOrderList,
  getRefundOrderList,
  page2School,
  getBasicData,
  getRevenueData,
  getTop5Data,
  getTuoguanData,
  getCourseTypeData,
  getOrgBasicData,
  getOrgTop5Data,
  getOrgTuoguanData,
  getOrgCourseTypeData,
  getFoodData,
  getFoodOrgData,
  getSchoolDetailNew,
  getBranchList,
  // v1.3.3
  getSchoolOrgList,
  getStudentQuerylistNew,
  getByDictCode,
  getStudentDetail,
  getSchoolOrgListMore
}
